import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Card from '../components/ui/Card'

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <Card className="p-8">
            <h1 className="text-3xl font-bold mb-6 text-center">Privacy Policy</h1>
            <p className="text-sm text-gray-500 mb-8 text-center">Last Updated: September 25, 2025</p>

            <div className="space-y-6">
              <section>
                <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
                <p className="text-gray-700 leading-relaxed">
                  FajrFighter is an Islamic service dedicated to helping the Muslim Ummah wake up for the Fajr prayer.
                  We take your privacy very seriously. This policy explains how we collect, use, and protect your
                  personal information.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">2. Information We Collect</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  We collect the following information in order to provide our services:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li><strong>Personal Information:</strong> Name, mobile number, email address</li>
                  <li><strong>Location Information:</strong> Timezone and general location to determine Fajr prayer times</li>
                  <li><strong>Service Information:</strong> Preferred call time, community membership</li>
                  <li><strong>Usage Information:</strong> App usage statistics, log data</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">3. How We Use Your Information</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  We use your information for the following purposes:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>Providing automated wake-up call service for Fajr prayer</li>
                  <li>Delivering community-based wake-up services</li>
                  <li>Displaying personal profiles and statistics</li>
                  <li>Analytics to improve service quality</li>
                  <li>Essential communication and support</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">4. Data Security</h2>
                <p className="text-gray-700 leading-relaxed">
                  We employ industry-standard security measures to protect your personal information.
                  All our data is secured through encryption, secure servers, and restricted access controls.
                  Only authorized personnel may access your information for necessary operational purposes.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">5. Data Sharing</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  We do not sell, rent, or distribute your personal information to third parties.
                  However, information may be shared in the following circumstances:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>With trusted telecom partners to deliver call services</li>
                  <li>As required by legal obligations or court orders</li>
                  <li>With your explicit consent</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">6. Cookies and Tracking</h2>
                <p className="text-gray-700 leading-relaxed">
                  Our website and app use cookies and similar technologies to enhance the user experience
                  and improve service quality. You can manage cookies through your browser settings.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">7. Your Rights</h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  You have the following rights:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>Access and update your personal information</li>
                  <li>Delete your account and associated data</li>
                  <li>Object to data processing</li>
                  <li>Request data portability</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">8. Children's Privacy</h2>
                <p className="text-gray-700 leading-relaxed">
                  Our service is not intended for children under the age of 13. We do not knowingly
                  collect personal information from children under 13.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">9. Changes to This Policy</h2>
                <p className="text-gray-700 leading-relaxed">
                  We may update this Privacy Policy from time to time. For any significant changes,
                  we will notify you via email or through the app.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">10. Contact Us</h2>
                <p className="text-gray-700 leading-relaxed">
                  If you have any questions or concerns about this Privacy Policy, please contact us:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg mt-4">
                  <p><strong>Email:</strong> privacy@fajrfighter.com</p>
                  <p><strong>WhatsApp:</strong> +880 1314-951751</p>
                  <p><strong>Address:</strong> Dhaka, Bangladesh</p>
                </div>
              </section>
            </div>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default PrivacyPolicy